import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import classnames from 'classnames';
import messages from '../../utils/translationMessages';
import { Cookies } from 'react-cookie';
import { get } from 'lodash';
import { bindActionCreators } from 'redux';
import { setGenericEvent } from '../../store/actions/dataLayer';
import { PortalConfigContext } from '../../config/portal';
import './styles.css';

const EVENT_CATEGORY = 'e_gdprCookieTracking';

class CookiesDisclaimer extends PureComponent {

  state = {
    show: false
  };

  componentDidMount() {
    window.addEventListener('pageshow', this.onPageShow);
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.onPageShow);
  }

  onPageShow = () => {
    const { cookies = {} } = this.props;
    const { name: portal } = this.context;
    const cookieControl = get(cookies, 'cookies.cookieControl');
    const gdpr = get(cookies, 'cookies.gdpr');
    const supportsDisclaimer = get(this.context, 'supports.cookiesDisclaimer', false);
    if (supportsDisclaimer && (!cookieControl && (!gdpr || gdpr === 'true'))) {
      this.props.setGenericEvent(EVENT_CATEGORY, 'displayed', portal);
      this.setState({ show: true });
    }
  }

  linkOnClick = () => {
    const { name: portal } = this.context;
    this.props.setGenericEvent(EVENT_CATEGORY, 'opened', portal);
  }

  acceptOnClick = () => {
    const { cookies } = this.props;
    const { name: portal } = this.context;
    let tillTheEndOfTime = new Date();
    tillTheEndOfTime.setDate( tillTheEndOfTime.getDate() + 99999 );
    const data = {
      value: 'true',
      expires: tillTheEndOfTime,
      path: '/'
    };
    cookies.set('cookieControl', 'true', data);
    this.props.setGenericEvent(EVENT_CATEGORY, 'accepted', portal);
    this.setState({ show: false });
  }

  denyOnClick = () => {
    const { cookies } = this.props;
    const { name: portal } = this.context;
    let tillTheEndOfTime = new Date();
    tillTheEndOfTime.setDate( tillTheEndOfTime.getDate() + 99999 );
    const data = {
      value: 'true',
      expires: tillTheEndOfTime,
      path: '/'
    };
    cookies.set('cookieControl', 'false', data);
    this.props.setGenericEvent(EVENT_CATEGORY, 'denied', portal);
    this.setState({ show: false });
  }

  closeOnClick = () => {
    const { cookies } = this.props;
    const { name: portal } = this.context;
    let tillTheEndOfTime = new Date();
    tillTheEndOfTime.setDate( tillTheEndOfTime.getDate() + 99999 );
    const data = {
      value: 'true',
      expires: tillTheEndOfTime,
      path: '/'
    };
    cookies.set('cookieControl', 'true', data);
    this.props.setGenericEvent(EVENT_CATEGORY, 'closed', portal);
    this.setState({ show: false });
  }

  render() {
    const { intl: { formatMessage: t } } = this.props;
    return (
      <>
        {
          this.state.show ?
            <div className={classnames('cookie-message', 'show')}>
              <button type="button" className="cookie-close" id="cookie-close" onClick={() => this.closeOnClick()}>&#x2715;</button>
              <div className="cookie-message-container">
                <div className="cookie-message-text-wrapper">
                  <div className="cookie-message-text">{t(messages.cookiesDisclaimer.disclaimer.p1)}</div>
                  <div className="cookie-message-text">{t(messages.cookiesDisclaimer.disclaimer.p2)}</div>
                  <div className="cookie-message-text">{t(messages.cookiesDisclaimer.disclaimer.p3)}</div>
                  <div className="cookie-message-text">{t(messages.cookiesDisclaimer.disclaimer.p4)} <a onClick={() => this.linkOnClick()} className="cookie-message-link" href={t(get(messages, 'footer.cookiesPolicy.url'))} target="_blank" rel="noopener noreferrer" id="cookies-policy">{t(messages.cookiesDisclaimer.disclaimer.policy)}</a>{t(messages.cookiesDisclaimer.disclaimer.p5)}</div>
                  <br /><br />
                  <div className="cookie-message-text">{t(messages.cookiesDisclaimer.disclaimer.p6)}</div>
                  <div className="cookie-message-text">{t(messages.cookiesDisclaimer.disclaimer.p7)}</div>
                </div>
                <div className="cookie-message-button-wrapper">
                  <button onClick={() => this.denyOnClick()} className="cookie-message-button" id="cookies-off">{t(messages.cookiesDisclaimer.deny)}</button>
                  <button onClick={() => this.acceptOnClick()} className="cookie-message-button" id="cookies-on">{t(messages.cookiesDisclaimer.accept)}</button>
                </div>
              </div>
            </div> : null
        }
      </>
    );
  }
}

CookiesDisclaimer.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  cookies: PropTypes.instanceOf(Cookies),
  setGenericEvent: PropTypes.func
};

CookiesDisclaimer.contextType = PortalConfigContext;

export default connect(
  undefined,
  (dispatch) => bindActionCreators({ setGenericEvent }, dispatch)
)(injectIntl(CookiesDisclaimer));
